



import i18n from '@/langs/i18n'
import {Component, Prop, Vue} from 'vue-property-decorator';

import {ServiceFactory} from "@/services";
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";
import HeaderLogo from "@/components/Atoms/HeaderLogo/HeaderLogo.vue";
import {COOKIES} from "@/constants";

const AuthService = ServiceFactory.get('auth');

@Component({
  components: {HeaderLogo, SvgRender}
})
export default class MainHeader extends Vue {
  @Prop({required: false, type: String, default: i18n.tc('common.label.searchResult').toString()})
  @Prop(String) currentRoute!: string

  private isBackEnable = false
  private title: any = ''

  private get isShowLogo(): boolean {
    return ['routes.home', 'routes.growTree', 'routes.album', 'routes.search'].includes(this.currentRoute);

  }

  private get isShowTitle(): any {
    if (this.currentRoute === 'routes.search.result') return i18n.tc('common.label.searchResult').toString()
    if (this.currentRoute === 'routes.change.user.info') return this.title = i18n.tc('common.label.setting').toString()
    if (this.currentRoute === 'routes.new.baby') return this.title = i18n.tc('common.label.addNewBaby').toString()
    return ''
  }

  private created(): void {
    this.isBackEnable = this.$route.meta && this.$route.meta.backToPreviousEnable
  }

  private onClickToLogo(): void {
    this.$router.push({name: 'routes.home'})
  }

  private onClickBackPage(): any {
    if (this.currentRoute == 'routes.new.baby') return this.$router.push({name: 'routes.change.user.info'})
    if (this.currentRoute == 'routes.search.result') return this.$router.push({name: 'routes.search'})
    return this.$router.push({name: 'routes.home'})
  }

  private onClickToMenu(): void {
    console.log('onClickToMenu')
    this.$emit('clickToMenu')
  }

  private async onClickLogout(): Promise<void> {
    let isLogout = await AuthService.logout().catch(() => false);
    if (isLogout === false) return

    this.$cookies.set(COOKIES.accessToken, '')
    await this.$router.push({ name: 'routes.auth.login' })
  }
}
